import { postRequest } from 'Services/baseRequests/postRequest'
import { RequestResponse } from 'Services/apiResponseTypes'

export type EmployerReceiptDownloadPayload = {
  employerId: number
  startDate: string
  endDate: string
}

type EmployerReceiptDownloadApiPayload = {
  start_date: string
  end_date: string
}

export const employerReceiptDownload = async ({
  employerId,
  startDate,
  endDate
}: EmployerReceiptDownloadPayload): Promise<RequestResponse> => {
  const response = await postRequest<RequestResponse, EmployerReceiptDownloadApiPayload>(
    `/employers/${employerId}/reports/download_receipts`,
    {
      start_date: startDate,
      end_date: endDate
    }
  )

  return {
    success: response?.success ?? false,
    message: ''
  }
}
